import React from 'react'
import { Card, Form, Input, Button } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { FormInstance } from 'antd/es/form'

interface ProfileFormProps {
    form: FormInstance
    loading: boolean
    onSubmit: (values: { username: string }) => Promise<void>
}

export const ProfileForm: React.FC<ProfileFormProps> = ({
    form,
    loading,
    onSubmit,
}) => {
    const { t } = useTranslation(['profile', 'common'])
    
    return (
        <Card>
            <Form form={form} layout="vertical" onFinish={onSubmit}>
                <Form.Item
                    name="username"
                    label={t('profile:basic.username')}
                    rules={[
                        { required: true, message: t('profile:basic.usernameRequired') },
                        { min: 4, message: t('profile:basic.usernameMinLength') },
                    ]}
                >
                    <Input prefix={<UserOutlined />} />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        {t('common:buttons.save')}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
